import { render, staticRenderFns } from "./stats-chart-cicle-total.vue?vue&type=template&id=5879436a&"
import script from "./stats-chart-cicle-total.vue?vue&type=script&lang=js&"
export * from "./stats-chart-cicle-total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports